import View from "../../../Account/Js/views/OrderStatusPopupView";
import components from "./components.js";
components.define("js-OrderStatusPopup", View);